/**
 * Strategy pattern for FAQ data retrieval
 */
import { DataDomainMetadata, ITShopFAQModel } from "lib/models/faq-models";

import { CatalogicalService } from "./catalogical-service";

export interface FAQDataService {
  getMetadata(): Promise<DataDomainMetadata>;
}

/**
 * API-based data provider
 */
export class FAQService extends CatalogicalService<ITShopFAQModel> implements FAQDataService {
  constructor() {
    super("itshopfaq");
  }

  async getMetadata(): Promise<DataDomainMetadata> {
    const response = await this.fetch(`/domains/${this.domain}/metadata`);
    return response.json();
  }
}

/**
 * Factory to create the appropriate provider
 */
export class FAQDataServiceFactory {
  static create(): FAQDataService {
    return new FAQService();
  }
}
